<template>
  <div>
    <div @click.stop="showPopover">
      <slot name="button" :title="modelValue?.title" :visible="visible">
        <UiButton
          severity="tertiary"
          class="flex items-center gap-1 !rounded-full !py-[9px] px-5 text-sm"
        >
          {{ modelValue?.title ?? placeholder }}
          <UiIcon
            name="chevron-down"
            class="size-4 text-icon-primary transition-transform"
            :class="{ 'rotate-180': visible }"
          />
        </UiButton>
      </slot>
    </div>
    <UiPopover ref="popover" @open="visible = true" @close="visible = false">
      <ul class="py-3">
        <li v-for="option in options" :key="option.title" class="text-sm" @click="change(option)">
          <slot name="option" :option="option" :is-active="modelValue?.title === option.title">
            <UiButtonLink
              severity="primary"
              size="small"
              class="flex w-full items-center gap-1 px-6 py-2 text-left text-sm"
            >
              {{ option.title }}
              <UiIcon v-if="modelValue?.title === option.title" name="check" class="size-2" />
            </UiButtonLink>
          </slot>
        </li>
      </ul>
    </UiPopover>
  </div>
</template>

<script setup lang="ts" generic="T extends SelectOption">
import { ref, useTemplateRef } from 'vue'
import UiButton from '../UiButton.vue'
import UiButtonLink from '../UiButtonLink.vue'
import UiIcon from '../UiIcon.vue'
import UiPopover from '../UiPopover.vue'
import type { SelectOption } from './type'

type PropType = {
  modelValue: T
  options: T[]
  placeholder?: string
}
type EmitType = {
  (e: 'update:modelValue', value: T): void
}

defineProps<PropType>()
const emit = defineEmits<EmitType>()

const visible = ref(false)
const change = (value: T) => {
  emit('update:modelValue', value)
  hidePopover()
}
const popover = useTemplateRef<typeof UiPopover>('popover')

const showPopover = (e: MouseEvent) => {
  popover.value?.toggle(e)
}
const hidePopover = () => {
  popover.value?.hide()
  visible.value = false
}
</script>
